import React from "react";
import { Plus, Trash2, X } from "lucide-react";
import AiPromptGenerator from "@/components/resume-builder/AiPromptGenerator";

const FIELD_CLASS = "bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400";

export default function CustomSectionsSection({ draft, setDraft }) {
  const sections = draft.custom_sections || [];

  const updateSection = (idx, field, value) => setDraft({ ...draft, custom_sections: sections.map((s, i) => (i === idx ? { ...s, [field]: value } : s)) });
  const removeSection = (idx) => setDraft({ ...draft, custom_sections: sections.filter((_, i) => i !== idx) });
  const addItem = (idx) => updateSection(idx, "items", [...sections[idx].items, ""]);
  const updateItem = (idx, itemIdx, value) => updateSection(idx, "items", sections[idx].items.map((it, i) => (i === itemIdx ? value : it)));
  const removeItem = (idx, itemIdx) => updateSection(idx, "items", sections[idx].items.filter((_, i) => i !== itemIdx));

  return (
    <>
      {sections.map((section, idx) => (
        <div key={idx} className="glass-panel rounded-2xl p-5" data-testid={`resume-section-custom-${idx}`}>
          <div className="flex items-center justify-between mb-3 gap-2">
            <input
              value={section.title} onChange={(e) => updateSection(idx, "title", e.target.value)}
              placeholder="Custom Section Title (e.g. Publications, Awards)" data-testid={`resume-custom-title-${idx}`}
              className={FIELD_CLASS + " flex-1 font-semibold"}
            />
            <button onClick={() => removeSection(idx)} data-testid={`resume-remove-custom-section-${idx}`} className="text-slate-400 hover:text-red-400 shrink-0"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
          <div className="space-y-1.5 mb-2">
            {section.items.map((item, itemIdx) => (
              <div key={itemIdx} className="flex items-center gap-2">
                <input value={item} onChange={(e) => updateItem(idx, itemIdx, e.target.value)} placeholder="Item / bullet point" data-testid={`resume-custom-item-${idx}-${itemIdx}`} className={FIELD_CLASS + " flex-1"} />
                <button onClick={() => removeItem(idx, itemIdx)} data-testid={`resume-remove-custom-item-${idx}-${itemIdx}`} className="text-slate-400 hover:text-red-400"><X className="w-3.5 h-3.5" /></button>
              </div>
            ))}
          </div>
          <button onClick={() => addItem(idx)} data-testid={`resume-add-custom-item-${idx}`} className="flex items-center gap-1 text-xs font-semibold text-indigo-300 hover:text-indigo-200">
            <Plus className="w-3.5 h-3.5" /> Add Item
          </button>
        </div>
      ))}
      <div className="glass-panel rounded-2xl p-5" data-testid="resume-section-custom-generate">
        <p className="text-sm font-semibold text-white mb-2">Generate a New Custom Section</p>
        <p className="text-xs text-slate-400 mb-3">e.g. Awards, Publications, Volunteering — describe it and AI creates a new section below.</p>
        <AiPromptGenerator section="custom" draft={draft} setDraft={setDraft} />
      </div>
    </>
  );
}
